import { ProgressLayout } from '@/components/features/progress/ProgressLayout';

export function ProgressPage() {
  return (
    <div className='flex h-full flex-col overflow-hidden'>
      <ProgressLayout />
    </div>
  );
}
